import Validator from '../Validator';
import ValidatorInterface from '../ValidatorInterface';
import * as moment from 'moment';

export default class ValidatorDate extends Validator implements ValidatorInterface {

    /**
     * Check if value is valid
     *
     * @param value
     * @param index
     * @param offset
     */

    public check(value: string, index: number, offset: number): boolean {

        // Validate date
        if (!moment(value).isValid()) {
            this.addError("Invalid date!",index,value);
            return false;
        }

        return true;
    }
}